import gql from 'graphql-tag';

/**
 * Data of the block project-employer-communication ("Kommunikation mit Auftraggeber"): ticket
 * category, question to and answer from the employer. Read through
 * `Project.blocks.employerCommunication`, which checks the block's read permission.
 */
export const PROJECT_EMPLOYER_COMMUNICATION_FIELDS = gql`
  fragment projectEmployerCommunicationFields on ProjectEmployerCommunicationBlock {
    id
    number
    askEmployerCategoryState
    askEmployerNote
    answerFromEmployerNote
  }
`;
